/* eslint-disable */

export default {
  // sign up page locales
  signup: {
    title: "Sign Up",
    console: "CONSOLE",
    signup: "SIGN UP",
    subtitle: "or sign in to your account",
    tos: "I agree to RELE.AI terms of service",
    privacy: "I agree to RELE.AI terms of Privacy",
    chooseMethod: "Create your account",
    veraficationEmailSentTitle: "A verification email has just been sent to you.",
    veraficationEmailSentDesc: 'To continue the login process, please click on the link "Sign in with RELE.AI" in the link attached to the email.',
    provideNumberDescription: "Hi 👋<br />Please provide your mobile number in order to give you access to RELE.AI, your CRM assistant.",
    createOrganizationDescription: "Please name your company.<br />Once created, you will be able to connect your CRM and invite team members.",
    firstIntegrationDescription: "Connect RELE.AI with one of the integrations below. You can always change it or add more integrations later on the integrations page.",
    steps: {
      createUser: "Create User",
      createOrganization: "Create Company",
      firstIntegration: "First Integration"
    },
    info: {
      tooltips: {
        console: "<div>• Please sign up with the email address you want to work with.<br /> • This information will be used to identify your account. <br /> • We prefer you to use google/microsoft for security reasons.</div>",
        createUser: "<div>• Creating a user in the RELE.AI<br /> • The phone number you provide <t /> here will be the number with which you will forward Whatsapp messages to RELE.AI.</div>",
        createOrganization: "<div>• Creating your company.<br /> • Each user in the system is associated with company.<br /> • At the end of the process, the user you created in the previous step will be associated with the company you are currently creating.<br /> • Once the registration process is complete, you can add more users who will be members of the same company you are currently creating.</div>",
        firstIntegration: "<div>Set first Integration</div>"
      }
    }
  },

  // global items
  globals: {
    search: "Search...",
    hi: "Hi,",
    contactClara: "Contact RELE.AI",
    page: "Page",
    authDivider: "or",
    month: "Month",
    year: "Year"
  },

  // payments pages
  payments: {
    // active subscription page
    activeSubscription: {
      dialogs: {
        update: {
          title: "Change Subscription Plan",
          description: "RELE.AI offers monthly and annual plans that can be viewed on our <a href=\"https://rele.ai/pricing/\" target=\"_blank\" about class=\"text-r-primary\">pricing page.</a><br />If you wish to move between plans, just select the plan you want from the drop down and click Save.",
          plans: "Plans",
        },
        delete: {
          title: "Cancel Subscription",
          description: "<div class=\"font-semibold\">We don't want you to go 😢</div><br />Are you sure you want to cancel your subscription?<br />Let's talk first <a href='mailto:support@rele.ai' class=\"text-r-primary\">support@rele.ai</a>",
        }
      },
      invoices: {
        title: "Invoices",
        created: "Invoice Date",
        amountPaid: "Paid Amount",
        invoicePdf: "Download Invoice",
        emptyItems: "No invoices yet",
      },
      subscriptionInfo: {
        title: "Subscription Details",
        startDate: "Start Date",
        plan: "Plan",
        price: "{amount} {currency}/User/{interval}",
        amountOfUsers: "User Count",
      }
    },
    table: {
      title: "Payments"
    },
    yearly: "Yearly Plans",
    monthly: "Monthly Plans",
    small: "Small",
    contactUs: "Contact Us",
    enterprise: "Enterprise",
    smallDescription: "Small or Medium business?<br />This plan supports up to 100 users",
    enterpriseDescription: "Have more than 100 users?<br />Let's get in touch",
    planLayout_monthly: "user/month",
    planLayout_yearly: "user/year",
    welcome: "We are so excited to have you with us! 🥳<br /><br />If you need any help just reach out to us at <a href='mailto:support@rele.ai' class='text-r-primary'>support@rele.ai</a>",
    errorOnCheckout: "Something went wrong 😕<br /><br />We will love to help you, just send us an email at <a href='mailto:support@rele.ai' class='text-r-primary'>support@rele.ai</a>",
    alertDialog: {
      title: "Your trial account is over",
      description: "Please arrange the payment through this page, and continue documenting through RELE.AI.",
      checkbox: "Do not show this message again"
    }
  },

  // user management page
  usersManagement: {
    csv: "CSV",
    csvIntro: "<div>Upload users using CSV files. <br /> For an example of valid CSV structure, click <a style='text-decoration: underline;' href=\"https://docs.google.com/spreadsheets/d/1EIpHIS7BmbmYMk_PkOSmyX3Z-m2t0_NFRdYTTu5vYwg/edit?usp=sharing\" target=\"_blank\">here</a></div>",
    csvTooltip: "<div><span style='font-weight: 600;'>CSV Notes:</span> <br> • The <b>mobile</b> should also include the prefix number of the country. For example: for the United States - +1 <br> • The <b>countryCode</b> should include the country code of the mobile number. For example: for a mobile with a United States prefix number, the countryCode would be US <br> • <b>botLang</b> is an optional value. You can set the bot language for specific user. You can choose between EN/FR/GR/ES when the default is the language on organization level</div>",
    user: "User",
    table: {
      name: "Employee Name",
      email: "Email Address",
      phone: "Mobile Number",
      actions: "Actions",
      title: "User Management",
      addNew: "Add User",
      noUserFound: "Opps. No users found matching your requirements.",
    },
    deleteDialog: {
      title: "Delete User",
      description: "Are you sure you want to delete {name}?"
    }
  },

  // active Integrations
  activeIntegrations: {
    integration: "Integration",
    table: {
      title: "Active Integrations",
      noIntegrations: "Oops!<br /> You have no active integration.<br /> Please enable one of the integrations and start documenting."
    }
  },

  // non-active Integrations
  nonActiveIntegrations: {
    title: "Marketplace",
    description: "To enable one of the integrations below, click on the integration card and follow the instructions.",
    hubspot: {
      title: "Hubspot Integration",
      description: "Integrate your Hubspot CRM account."
    },
    salesforce: {
      title: "Salesforce Integration",
      description: "Integrate your Salesforce CRM account."
    },
    mailing: {
      title: "Mail Integration",
      description: "Integrate your Mail account."
    },
    noIntegrations: "Congrats! <br /> You have activated all the integrations."
  },

  // integration section
  integrations: {
    apps: {
      unknownAppError: "Unknown application, be careful",
      unexpectedRedirect: "Unexpected rediret, please make sure you authorized the correct application",
      unknown: {
        displayName: "Unknown Application",
        description: "Do not grant this application access if you're not sure what you're doing!"
      }
    },
    table: {
      title: "Integrations"
    },
    crm: {
      giveCarlaAccess: "To connect RELE.AI please follow these steps",
      title: "CRM Integrations",
      noCrmConnections: "You still haven't provided RELE.AI with access to your CRM.",
      connectCrm: "Connect CRM",
      apiKey: "Access Token:",
      updateConnection: "Edit",
      selectCRM: "Select a CRM",
      salesforce: {
        guide: "<ol class=\"list-decimal\"><li>Login to Salesforce by clicking on the button below</li><li>Approve access to RELE.AI</li></ol>",
        releaiPackage: "<div>• Before Sign In with Salesforce, your must link your Salesforce account with the RELE.AI Salesforce App. <br /><div style='margin-top: 10px;'>• Please check with your Salesforce Admin that the app is already installed. If it is not installed, you can do so by clicking <a style='color: blue;' href=\"https://login.salesforce.com/packaging/installPackage.apexp?p0=04t3z000001zs7p\" target=\"_blank\">here</a>.</div><div style='margin-top: 10px;'>• For more info: <a style='color: blue;' href=\"https://rele.ai/how-to-connect-salesforce/\" target=\"_blank\">https://rele.ai/how-to-connect-salesforce</a></div></div>"
      },
      hubspot: {
        chooseAuth: {
          oauth: "Sign in with HubSpot",
          apiKey: "Access Token",
          title: "Choose Authenticated method",
          description: "Please select your connection to the hubspot. You can choose to connect using the API Key from your hubspot account, or using OAuth login.",
          chooseAuthMethodTitle: "Which Hubspot's authentication method should I choose?",
          chooseAuthApiKeyDesc: "<div>Connecting to hubpost using <span style='font-weight: 800'>API Key</span> will give permission to <span style='font-weight: 800'>all users</span> you add under the RELE.AI Console to use Hubpsot.</div>",
          chooseAuthOauthDesc: "<div>Connecting to hubpost using <span style='font-weight: 800'>Sign in With HubSpot</span> will give permission <span style='font-weight: 800'>only to your user</span> to use Hubpsot.</div>",
          tooltips: {
            apiKey: "<div><div>To retrieve your API Key from hubspot:</div><div style='margin-top: 3px;'><span style='font-weight: 800'>1. </span>Visit <a href=\"https://app.hubspot.com/\" target=\"_blank\" about class=\"text-r-primary\">https://app.hubspot.com/</a></div><div><span style='font-weight: 800'>2. </span>Select your Husbpot Account</div><div></div><span style='font-weight: 800'>3. </span>Access hubspot settings by clicking on your Profile -> Profile & preferences<div><span style='font-weight: 800'>4. </span>On the left menu go to Integrations and then API key</div><div><span style='font-weight: 800'>5. </span>Copy the API key and paste it in the input on the next step.</div></div>",
            oauth: "<div><div>Please note that you must inform your team members (RELE.AI users) they must follow these steps:</div><div style='margin-top: 3px;'><span style='font-weight: 800'>1.</span> Visit <a href=\"https://console.rele.ai\" target=\"_blank\" about class=\"text-r-primary\">https://console.rele.ai</a></div><div><span style='font-weight: 800'>2.</span> Visit the integrations section</div><div><span style='font-weight: 800'>3.</span> Select HubSpot</div><div><span style='font-weight: 800'>4. </span>Login with HubSpot login</div></div>"
          }
        },
        guideOauth: "<ol class=\"list-decimal\"><li>Login to Hubspot by clicking on the button below</li><li>Approve access to RELE.AI</li></ol>",
        guideApiKey: "<ol class=\"list-decimal\"><li>Login to your HubSpot account</li><li>Access hubspot settings by clicking on your Profile -> Profile & preferences</li><li>On the left menu go to Integrations -> Private Apps -> Create a Private App </li><li>Copy the Access Token and paste it in the input below</li></ol>",
        docs: {
          part1: "Did not find it? Please visit",
          link: "this",
          part2: "link for more explanation"
        }
      },
      deleteDialog: {
        title: "Delete Integration",
        description: "Are you sure you want to delete {name} integration?"
      }
    },
    mailing: {
      guide: "You can add email addresses to which you can forward messages to RELE.AI.",
      checkbox: {
        enable: "Email is enabled.",
        disable: "Email is disabled",
        disableInfo: "Please add an email address to your to enable the email feature."
      }
    }
  },

  // notification
  notifications: {
    trailEndIn: "Your trial ends {days}. Please complete your payment's information. 🤑",
    editSuccess: "Congrats! You just updated {name}.",
    createSuccess: "Congrats! You just created {name}.",
  },

  // forms
  forms: {
    firstname: "First Name",
    lastname: "Last Name",
    email: "Email Address",
    mobile: "Mobile Number",
    workspace: "Company Name",
    botLang: "Preferred bot language",
    claraNumber: "Preferred bot number",
    password: "Password",
    csvInfo: "<div>You can Drag and drop CSV file, or <span style='text-decoration: underline;'>click here</span> to upload a file.<div>",
    tabs: {
      manual: "Manual",
      csvs: "Import CSV"
    }
  },

  // input placeholders
  placeholders: {
    enterYourEmail: "Enter your email address",
    enterYourPassword: "Enter your password"
  },

  // buttons
  buttons: {
    continueWithGoogle: "Continue With Google",
    continueWithMicrosoft: "Continue With Microsoft",
    signInWithEmailAndPassword: "Sign In with email and password",
    next: "Next",
    back: "Back",
    getStarted: "Next",
    exportCsv: "Export to CSV",
    edit: "Edit",
    save: "Save",
    delete: "Delete",
    cancel: "Cancel",
    signOut: "Sign Out",
    continueWithEmail: "Continue With Email",
    continueWithSalesforce: "Continue With Salesforce",
    continueWithHusbpot: "Continue With Hubspot",
    botSettings: "Bot Settings",
    changePlan: "Change Plan",
    cancelSubscription: "Cancel Subscription",
    consoleSettings: "Console Settings",
    close: "Close",
    ok: "OK",
    authorize: "Authorize",
    deleteCompany: "Delete Company"
  },

  // delete company dialog
  deleteCompany: {
    title: "Delete Company",
    description: "<div>Are you sure you want to delete the company with all existing users in it? <br/> <div style='margin-top: 10px;'><span style='color: red; font-weight: 800'>WARNING:</span> After deleting the company, you will not be able to go back. All users who were linked to the company will be deleted.</div></div>"
  },

  errors: {
    unableToAuthenticateTitle: "Unable to complete authentication",
    unableToDropFile: "Unable to drop file",
    unableToSignOut: "Unable to sign out user",
    missingRequiredField: "Missing required fields",
    unableToCreateUser: "Unable to create user",
    unableToDeleteUser: "Unable to delete user",
    unableToLoginWithSalesforce: "Unable to login with Salesforce.",
    unableToLoginWithHubspot: "Unable to login with Husbpot.",
    unableToEnableMailing: "Unable to add Emails.",
    unableToCreatePaymentSubscription: "Unable to make a payment.",
    unableToChangeSubscription: "Unable to change subscription plan.",
    unableToCancelSubscription: "Unable to cancel subscription. Please contact our support team.",
    unableToDeleteIntegration: "Unable to delete integration.",
    unableToSaveBotSettings: "Unable to save bot settings.",
    workspaceNameRequired: "Workspace name is required",
    unableToCreateNewOrg: "Unable to create company.",
    unableToDeleteCompany: "unable to delete company.",
    unableToUpdateUserWithOrgId: "Unable to attach the user to the company",
    validateEmail: "Invalid Email Address. Please enter a valid email address.",
    validateFirstName: "Invalid first name. Do not enter spaces or special characters.",
    validateLastName: "Invalid last name. Do not enter special characters beside `-`",
    validateMobile: "There is an existing user with the same number.",
    validateHubspotAPIKey: "The API key is invalid. Please click on the link above for an explanation of how to find it."
  },

  botOptions: {
    inherit: "Default Company Language",
    en: "English",
    es: "Spanish",
    fr: "French",
    gr: "German",
    pt: "Portuguese"
  },

  botSettings: {
    title: "Bot's settings"
  },

  consoleSettings: {
    title: "Console settings",
    locale: "Console language"
  }
}
